import {
    receive_trending,
    reset_trending,
} from "../../reducers/Trending/reducer";
import {
    hasTrending,
    getSection,
    getTrendingSection,
} from "../../utils/trending";
import { NUM_TRENDING_STORIES } from "./constants";
import logger from "../../utils/logger/library";

/**
 * Makes an API call to fetch trending data for the given section
 * restricted to sections defined in @see SECTIONS
 * using trendingSection in place of site sesction if present
 * @param {string} section - trending section name
 * @return {object} Result of the API call
 */
export function fetch_trending(siteSection) {
    return (dispatch) => {
        if (hasTrending(siteSection)) {
            let trendingSection = getTrendingSection(siteSection);
            return dispatch(fetch_single_trending(trendingSection));
        } else {
            dispatch(reset_trending());
            return Promise.resolve();
        }
    };
}

/**
 * Fetch trending section (which is assumed to be supported)
 * exported only for testing purposes
 * @param {string} section
 * @return {Promise}
 */
export function fetch_single_trending(section) {
    return async (dispatch) => {
        try {
            const contentList = await getSection(section, NUM_TRENDING_STORIES);
            if (!Array.isArray(contentList)) {
                throw new Error("trending items expected to be of type array");
            }
            return dispatch(receive_trending({ section, contentList }));
        } catch (error) {
            logger.error(`(fetch_single_trending) ${error}`);
        }
    };
}
